<template>
  <validation-observer tag="form"
                       ref="observer"
                       @submit.prevent="submit">
    <slot />
  </validation-observer>
</template>

<script>
import { ValidationObserver } from "vee-validate";

export default {
  components: {
    ValidationObserver,
  },

  data() {
    return {};
  },

  props: {},

  computed: {},

  watch: {},

  methods: {
    async submit() {
      const isValid = await this.$refs.observer.validate();

      if (isValid) {
        this.$emit("submit");
      }
    },
    async validate() {
      return this.$refs.observer.validate();
    },
    reset() {
      this.$refs.observer.reset();
    }
  },
};
</script>

<style lang="scss" scoped></style>
